import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const Qualifications = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.5 } }
  };

  const qualificationCategories = [
    {
      id: 'business',
      title: 'Business Credentials',
      items: [
        'Kentucky Licensed General Contractor',
        'Fully Insured',
        'Workers\' Compensation',
        'Business Registration',
        'Tax Compliance'
      ]
    },
    {
      id: 'quality',
      title: 'Quality Standards',
      items: [
        'Safety Certified',
        'Building Code Expertise',
        'Environmental Compliance',
        'Quality Assurance',
        'Professional References'
      ]
    },
    {
      id: 'government',
      title: 'Government Contracting',
      items: [
        'Federal Contract Experience',
        'SAM Registration',
        //'DUNS Number',
        //'Compliance Training',
        'Certified Performance'
      ]
    },
    {
      id: 'financial',
      title: 'Financial Stability',
      items: [
        'Established Business',
        'Bonding Capacity',
        'Credit Rating',
        'Insurance Coverage',
        'Financial Transparency'
      ]
    }
  ];

  return (
    <section id="qualifications" className="qualifications-section">
      <div className="container">
        <div className="section-title centered">
          <h2>Our Qualifications</h2>
          <p>Professional Credentials & Standards</p>
        </div>

        <div className="qualifications-intro">
          <p>
            J&C Renovations maintains the highest standards of professional qualifications
            and credentials, ensuring we meet and exceed all requirements for both private
            and government contracting work. Our commitment to excellence is backed by
            proper licensing, certifications, and a proven track record of compliance.
          </p>
        </div>

        <motion.div 
          className="qualifications-grid"
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
        >
          {qualificationCategories.map((category) => (
            <motion.div 
              key={category.id} 
              className="qualification-card"
              variants={itemVariants}
            >
              <h3>{category.title}</h3>
              <ul className="qualification-list">
                {category.items.map((item, index) => (
                  <li key={index}>
                    <span className="check-icon">✓</span>
                    {item}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </motion.div>

        <div className="government-focus">
          <div className="gov-badge">
            <span>Federal Contractor Ready</span>
          </div>
          <h3>Ready for Government Contracting</h3>
          <p>
            J&C Renovations is fully prepared to meet the rigorous standards and requirements
            of federal, state, and local government contracts. Our team understands the unique
            specifications, compliance requirements, and documentation needed for successful
            government project delivery.
          </p>
          <div className="gov-cta">
            <a href="#contact" className="btn btn-primary">Discuss Your Government Project</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualifications;
